export const createResponsiveClassNames = (
  styles, 
  prefix, 
  value
  ) => {
    const cx = Array.isArray(value) ? value : [value];
  
    return [
      styles[prefix + cx[0]],
      cx.length > 1 && styles['md:' + prefix + cx[1]],
    cx.length > 2 && styles['lg:' + prefix + cx[2]],
  ];
}